import { createPricingHolidayRequest } from "../../data/pricingHolidayApi";
import { validatePricingHolidayPayload } from "../validator/validatePricingHolidayPayload";

export async function createPricingHolidayUseCase(payload) {
  const error = validatePricingHolidayPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createPricingHolidayRequest(payload);
}
